import React from 'react';

import { BasicProfile, ProfileLine } from '@paragon/contract-library/lib/designService';

import { calculateProfileLineGeometry } from '../../library/profiles/profileManipulation';
import { WebJointSegmentVisual } from './WebJointSegmentVisual';
import { WebJointVisual } from './WebJointVisual';

interface ProfileLineVisualProps {
  readonly profile: BasicProfile;
  readonly profileLine: ProfileLine;
  readonly registerForRaycasting: boolean;
  readonly shouldShowWebbingVisuals: boolean;
}

export const ProfileLineVisual = (props: ProfileLineVisualProps) => {
  const webJointSegments = props.profileLine.webJointSegments.map((webJointSegment) => (
    <WebJointSegmentVisual
      key={webJointSegment.guid}
      profile={props.profile}
      profileLine={props.profileLine}
      webJointSegment={webJointSegment}
      registerForRaycasting={props.registerForRaycasting}
      shouldShowWebbingVisuals={props.shouldShowWebbingVisuals}
    />
  ));

  const segmentGeometry = calculateProfileLineGeometry(props.profile, props.profileLine);

  const joints = props.shouldShowWebbingVisuals
    ? props.profileLine.fixedJoints
        .map((fixedJoint) => (
          <WebJointVisual
            key={fixedJoint.guid}
            webJoint={fixedJoint}
            segmentGeometry={segmentGeometry}
            jointType="fixed"
            registerForRaycasting={props.registerForRaycasting}
          />
        ))
        .concat(
          props.profileLine.featureJoints.map((featureJoint) => (
            <WebJointVisual
              key={featureJoint.guid}
              webJoint={featureJoint}
              segmentGeometry={segmentGeometry}
              jointType="feature"
              registerForRaycasting={false}
            />
          )),
        )
    : null;

  return (
    <group>
      {webJointSegments}
      {joints}
    </group>
  );
};
